import {
  EmployeeDetailsDto,
  EmployeeInterface,
} from '../dto/employee-details.dto';

export const mapEmployeeDetails = (
  data: EmployeeDetailsDto
): EmployeeInterface => ({
  id: data.employeeGlobalId,
  uuid: data.id,
  globalId: data.employeeGlobalId,
  email: data.employeeEmail,
  name: data.employeeName,
  position: data.positionTitle,
  manager: data.managerName,
  band: data.band,
  zone: data.zone ?? undefined,
  country: data.countryBU,
  departmentFunction: data.departmentFunction,
  department: data.department,
});
